import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var False = props => {
  var {
    False: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'False');
  return null;
};
False.displayName = 'JVR.False';